import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import HomeHero from "../components/home-page/home-hero"
import StatusPages from "../components/status-page-carousel"
import HomeCta from "../components/home-page/home-cta"
import Clients from "../components/clients-logo-list"
import Testimonials from "../components/testimonials"
import PricingComponent from '../components/pricing-page/pricing-component'
import Blog from "../components/home-page/blog"

const IndexPage = () => (
  <Layout>
    <HomeHero />
    <HomeCta />
    <PricingComponent/>
    <Testimonials />
    <Clients />
    <StatusPages />
    <Blog />
  </Layout>
)

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => (
    <>
        <Seo title="Hosted Status Pages" />
        <meta name="description" content="Status pages that build trust - One tool for incidents, maintenance & general announcements." />
        <meta property="og:description" content="Status pages that build trust - One tool for incidents, maintenance & general announcements."  />
        <meta name="twitter:description" content="Status pages that build trust - One tool for incidents, maintenance & general announcements.Looking for a Status Page? With Sorry™, our Status Pages fit into your incident workflow right away." />
        <link rel="canonical" href="https://www.sorryapp.com/" data-gatsby-head="true" />
    </>
)

export default IndexPage
